import { render, staticRenderFns } from "./BusView.vue?vue&type=template&id=6ac47afc&scoped=true&"
import script from "./BusView.vue?vue&type=script&lang=js&"
export * from "./BusView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac47afc",
  null
  
)

export default component.exports